<script setup>
import PaginationButtons from "@/components/global-themed/PaginationButtons.vue";
import EmailLogsTableHeader from "@/components/email-logs/partials/EmailLogsTableHeader.vue";
import EmailLogsTable from "@/components/email-logs/partials/EmailLogsTable.vue";
import EmailHtmlModal from "@/components/email-logs/EmailHtmlModal.vue";
import {useEmailLogs} from "@/composables/email-logs/useEmailLogs";

defineProps({
  emailAddresses: {
    type: Object,
    default: () => {},
  }
})

const {currentPage, lastPage, showModal, handlePageChange} = useEmailLogs();
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-flex-col tw-gap-y-8">
      <div class="tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex tw-items-center tw-gap-4">
          <h1 class="tw-font-bold tw-text-4.5xl tw-text-neutral-900">
            Email Logs
          </h1>
        </div>
      </div>

      <div
        class="tw-bg-white tw-p-8 tw-rounded-lg tw-flex tw-flex-col tw-gap-y-4 tw-items-center"
      >
        <EmailLogsTableHeader :email-addresses="emailAddresses" />
        <EmailLogsTable />
        <PaginationButtons
          :last-page="lastPage"
          :current-page="currentPage"
          @change="(page) => handlePageChange(page)"
        />
      </div>
    </div>
  </div>

  <EmailHtmlModal v-if="showModal" />
</template>
